import { useTranslation } from 'react-i18next';
import { Badge, type BadgeVariant } from '@/components/ui/badge';
import type { ProductionDeclarationStatusCode } from '@/types/core/purchase-order/production-declaration-status-code';

const PRODUCTION_DECLARATION_BADGE_VARIANT_BY_STATUS: Record<
  ProductionDeclarationStatusCode,
  BadgeVariant
> = {
  pending: 'blue',
  submitted: 'orange',
  approved: 'green',
};

const PRODUCTION_DECLARATION_BADGE_BORDER_BY_STATUS: Record<
  ProductionDeclarationStatusCode,
  string
> = {
  pending: 'border-blue-400 dark:border-blue-500',
  submitted: 'border-orange-400 dark:border-orange-500',
  approved: 'border-green-500 dark:border-green-600',
};

type PurchaseOrderMainProductionDeclarationStatusBadgeProps = {
  status: ProductionDeclarationStatusCode;
};

export function PurchaseOrderMainProductionDeclarationStatusBadge({
  status,
}: PurchaseOrderMainProductionDeclarationStatusBadgeProps) {
  const { t } = useTranslation('purchaseOrder');
  const borderClasses = `border-2 ${PRODUCTION_DECLARATION_BADGE_BORDER_BY_STATUS[status]}`;

  return (
    <Badge
      className={`rounded-full px-4 py-1 ${borderClasses}`}
      variant={PRODUCTION_DECLARATION_BADGE_VARIANT_BY_STATUS[status]}
    >
      {t(`productionDeclarationStatus.${status}`)}
    </Badge>
  );
}
